var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('MainHeader'),_c('AdBanner'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"featured"},[_c('div',{staticClass:"featured-title"},[_vm._v("FEATURED CHARACTERS")]),_c('FeaturedCharacters')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }